import { parseISO, isSameDay, isBefore, isAfter } from 'date-fns'
import { parseDate, dateToStringWithFormat } from '@/utils/dateFormat'
import { toCamelCaseObject } from '@/utils/object'
import { toCamelCase } from '@/utils/string'

/*
 * 仮押さえ
 */

export const isNurseryAccept = (
  tartgeDateString: string,
  nurseryFromDateString: string,
  nurseryToDateString: string,
) => {
  const tartgeDate = parseISO(tartgeDateString)
  const fromDate = parseISO(nurseryFromDateString)
  const toDate = parseISO(nurseryToDateString)

  return (
    isSameDay(fromDate, tartgeDate) ||
    isSameDay(toDate, tartgeDate) ||
    (isBefore(fromDate, tartgeDate) && isAfter(toDate, tartgeDate))
  )
}

/*
 * 完了報告
 */

export const buildSupportEvent = (
  eventType: ISupportEventType,
  startDate: Date,
  startHour: string,
  startMinute: string,
  defaultChildIds: number[],
): ISupportEvent => {
  if (
    eventType === 'Start' ||
    eventType === 'Finish' ||
    eventType === 'Handover' ||
    eventType === 'TakeCare'
  ) {
    return {
      eventType,
      startDate,
      startHour,
      startMinute,
      children: defaultChildIds.map((id) => String(id)),
      handoverLocation: null,
      handoverLocationName: undefined,
      handoverPerson: null,
      handoverPersonName: undefined,
    }
  } else {
    return { eventType, startDate, startHour, startMinute }
  }
}

export const convertToSupportEvents = (
  events: IEventApi[],
): ISupportEvent[] => {
  const suportEvents = events.map((event) => {
    const startDate = parseDate(event.start_time)
    const startHour = dateToStringWithFormat(startDate, 'HH')
    const startMinute = dateToStringWithFormat(startDate, 'mm')

    return {
      ...toCamelCaseObject(event),
      eventType: toCamelCase(event.event_type, true) as ISupportEventType,
      startDate,
      startHour,
      startMinute,
      children: !!event.children
        ? event.children.map((childId) => String(childId))
        : [],
    }
  })

  return suportEvents
}

export const initSupportEvents = (
  defaultSupportEvents: IEventApi[],
  startDate: Date,
  startHour: number,
  startMinute: number,
  defaultChildIds: number[],
): ISupportEvent[] => {
  let events: ISupportEvent[] = []
  if (defaultSupportEvents?.length > 0) {
    events = convertToSupportEvents(defaultSupportEvents)
  }
  // サポート開始がなかったら追加する
  if (!events.some((event) => event.eventType === 'Start')) {
    const eventStart = buildSupportEvent(
      'Start',
      startDate,
      startHour.toString().padStart(2, '0'),
      startMinute.toString().padStart(2, '0'),
      defaultChildIds,
    )
    return [eventStart, ...events]
  }

  return events
}
